import * as React from "react";
import {Box, CircularProgress, Typography} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FilledButton from "../../components/buttons/FilledButton";

function PrimaryRecordPanelHeader({isExporting, onExport}) {
    const exportIcon = isExporting ? <CircularProgress size={16} color="inherit"/> : <FileDownloadIcon/>;
    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" sx={{margin: '.8em 0'}}>
            <Typography variant="h3" sx={{fontSize: '1rem', margin: 0}}>Documento por documento</Typography>
            <FilledButton disabled={isExporting} onClick={onExport}>
                {exportIcon}
                Exportar a Excel
            </FilledButton>
        </Box>
    );
}

export default PrimaryRecordPanelHeader;
